var App = App || {};

App.Disclaimers = (function ($) {
    'use strict';
    function init() {

        // if more than one modal-disclaimers - remove the empty ones
        var mcount = $(".modal-disclaimers").length;
        var mrem = 0;
        if ( mcount > 1) {
            $(".modal-disclaimers").each(function () {
                if ((mrem + 1) < mcount) {
                    if ($(this).find($(".modal-body")).children().length === 0) {
                        $(this).remove();
                        mrem++;
                    }
                }
            });
        }

        // append any placeholder disclaimer text into component items
        $(".disclaimer-fulltext").each(function () {

            var id = $(this).attr("id").replace("-placeholder", "");
            var uid = $(this).attr("data-uniqueid");
            var text = $(this).text();

            if ($('#' + id).length == false) {

                if ($(".component-disclaimers .container .item-disclaimer").length) {
                    var container = $(".component-disclaimers .container");
                    container.append("<div class=\"item-disclaimer\" id=\"" + id + "\"><div class=\"item-disclaimer-number\">" + uid + "</div><div class=\"item-disclaimer-content\">" + text + "</div></div>");
                }

                if ($(".modal-disclaimers").length) {
                    var container = $(".modal-disclaimers .modal-body");
                    container.append("<div class=\"item-disclaimer\" id=\"" + id + "\" data-unique-id=\"" + id.replace("item-disclaimer-", "") + "\"><div class=\"item-disclaimer-content\"><div class=\"item-disclaimer-content\">" + text + "</div></div>");
                }
            }
        });

        // if disclaimers set to display as icon tooltip style
        if ($(".modal-disclaimers").length) {

            // move modal to bottom of site-modals container
            $(".modal-disclaimers").appendTo(".site-modals");

            // turn superscript numbers into triggers for the modal
            $("sup").each(function () {

                var u = $(this).parent().data('disclaimerguid');
                var s = u ? u : $(this).html();

                if (!isNaN(parseInt(s)) || s == "*" || s == u) {
                    if ($(".item-disclaimer[data-unique-id='" + s + "']").length) {
                        $("<button class='btn-disclaimer' data-bs-unique-id='" + s + "' aria-label='View disclaimer " + $(this).html() + "' data-bs-toggle='modal' data-bs-target='#modal-disclaimers'><i class='fa-solid fa-circle-info'></i></button>").insertAfter($(this));
                        $(this).remove();
                    }
                }
            });

            var disclaimersModal = document.getElementById('modal-disclaimers')
            var timer;

            $('.btn-disclaimer').on({
                'mouseover': function () {
                    var button = $(this);

                    $('.btn-disclaimer').removeClass("active");
                    $(this).addClass("active");

                    timer = setTimeout(function () {
                        button.trigger('click');
                    }, 1000);
                },
                'mouseout': function () {
                    clearTimeout(timer);
                },
                'click': function (e) {
                    e.stopPropagation();
                    if ($(this).parents("a").length) {
                        e.preventDefault();
                    }
                    var w = $(window).width();
                    var p = $(this).offset();
                    var o = $(this).offset().top - $(window).scrollTop();
                    var hs = w < 768 ? 150 : 250; // adjust 'half size' for media query css rules on width
                    var l = p.left - hs;
                    var ml = 20; // left margin

                    // adjust positioning to prevent modal cut off by screen edge
                    if ((l + (hs * 2) + 20) > (w)) { 
                        l = w - (hs * 2);
                        ml = -6;
                    }
                    l = l < 6 ? 6 : l; 

                    $(".modal-disclaimers .modal-fixedpos").css({
                        position: "fixed",
                        marginLeft: ml,
                        marginTop: 20,
                        left: l,
                        top: o,
                    });
                }
            });
            $("html").on("mousemove", function (e) {
                if ($(".modal-disclaimers").is(":visible")) {
                    timer = setTimeout(function () {
                        if ($(".modal-fixedpos:hover").length == 0 && $(".btn-disclaimer.active:hover").length == 0) {
                            $(".modal-disclaimers").modal("hide");
                        }
                    }, 1000);
                }
            });

            disclaimersModal.addEventListener('show.bs.modal', function (event) {
                var button = event.relatedTarget;
                var s = button.getAttribute('data-bs-unique-id');
                $(".item-disclaimer[data-unique-id='" + s + "']").show();
            })

            disclaimersModal.addEventListener('hide.bs.modal', function (event) {
                $(".modal-disclaimers .item-disclaimer").hide();
                //$('.btn-disclaimer').removeClass("active");
            })

        }

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Disclaimers.init();
});